#import "../fragments/next-steps-nutshell-notification-fragment.graphql"

mutation FormNextStepsNutshellNotificationSet($input: FormNextStepsNutshellNotificationSetInput!) {
    formNextStepsNutshellNotificationSet(input: $input) {
        nutshellNotification {
            ...NextStepsNutshellNotificationFragment
        }
    }
}
